import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentUserPermissions } from '@/reducers/auth/currentUser.actions'
import { fetchUserSettings } from '@/reducers/userSettings/userSettings.actions'

// An admin can change a user's roles while that user has the app open. Without
// a refetch the open tab keeps showing what the old role allowed and every
// click 403s, so permissions are re-read when the tab comes back into view —
// throttled, since switching tabs is frequent and the answer rarely changes.
const PERMISSIONS_REFRESH_INTERVAL_MS = 60 * 1000

// on refresh, if the user has a token in localStorage, we hit the BE to get up to date permissions
const UserPermissionsProvider = () => {
  const dispatch = useDispatch()
  const { user_id, organizationid, own_organization_id } = useSelector((state) => state.currentUser)

  useEffect(() => {
    if (!user_id) {
      return undefined
    }

    const organizationId = own_organization_id || organizationid
    let lastFetchedAt = Date.now()

    dispatch(fetchCurrentUserPermissions(user_id, organizationId))
    dispatch(fetchUserSettings())

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        return
      }

      if (Date.now() - lastFetchedAt < PERMISSIONS_REFRESH_INTERVAL_MS) {
        return
      }

      lastFetchedAt = Date.now()
      // permissions only: no job-function modal, no hierarchy refetch
      dispatch(fetchCurrentUserPermissions(user_id, organizationId, { refresh: true }))
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [user_id])

  return null
}

export default UserPermissionsProvider
